import { Controller } from 'react-hook-form';
import { ValidatedAddressDialogFieldProps } from '../../types';
import { useErrorProps } from '../useErrorProps';
import { requiredErrorMessage, tooLongErrorMessage } from '../constants';
import { AutofillTextField } from '../AutofillTextField';

export const StreetAddress = ({ control, fieldErrors }: ValidatedAddressDialogFieldProps) => {
    const { error, helperText } = useErrorProps('streetAddress', fieldErrors);

    return (
        <Controller
            name="streetAddress"
            control={control}
            rules={{ required: requiredErrorMessage, maxLength: { value: 255, message: tooLongErrorMessage } }}
            render={({ field }) => (
                <AutofillTextField
                    // eslint-disable-next-line react/jsx-props-no-spreading
                    {...field}
                    error={error}
                    helperText={helperText}
                    label="Street Address"
                    autoFillKey="address-line1"
                    placeholder="123 Pine St"
                    required
                    fullWidth
                />
            )}
        />
    );
};
